import React, { useRef, useState, useEffect } from 'react';
import maps from '@tme/maps-wrapper';
import './RunToyotaMap.css';
import { I18N } from '../../../../constants';
import { formatDateTime } from '../../../../shared/utils/date';
import truckImageUrl from '../../../../images/truck.png';
import manualMarkerUrl from '../../../../images/manualMarker.png';
import gpsMarkerUrl from '../../../../images/gpsMarker.png';

export default function (props) {

    const mapsElement = useRef();
    const [stopObj, setStopObj] = useState({});
    const [gpsLocation, setGpsLocation] = useState({});
    var previousStop = 0;
    var previousGPSLocation = 0;

    const isEqual = (l1, l2) => {

        return (l1 &&
            l2 &&
            l1.latitude === l2.latitude &&
            l1.longitude === l2.longitude &&
            l1.timestamp === l2.timestamp);
    }

    const frameElement = (textArg, valueArg) => {

        const element = document.createElement('p');
        const text = document.createElement('span');
        text.setAttribute("class", "text-bold-style");
        text.textContent = textArg;
        const value = document.createElement('span');
        value.textContent = valueArg;
        element.appendChild(text);
        element.appendChild(value);
        return element;
    }

    const frameMarker = (markerUrl, markerStyle) => {

        const marker = document.createElement('img');
        marker.src = markerUrl;
        marker.setAttribute("class", markerStyle);
        return marker;
    }

    const frameOverlay = (id, overlayContainer) => {

        const overlay = document.createElement('div');
        overlay.setAttribute("id", id);
        overlay.setAttribute("class", "overlay");
        overlay.appendChild(overlayContainer);
        return overlay;
    }


    const frameStopOverlayHeader = (stop) => {

        const overlayHeader = document.createElement('div');
        overlayHeader.setAttribute("class", "overlay-header");
        overlayHeader.textContent = stop.stopName;
        return overlayHeader;
    }

    const frameStopOverlayBody = (stop) => {

        const overlayBody = document.createElement('div');
        overlayBody.setAttribute("class", "stop-overlay-body");
        overlayBody.appendChild(frameElement("Stop type: ", I18N.STOP_TYPE[stop.stopType]));
        overlayBody.appendChild(frameElement("Planned arrival: ", formatDateTime(stop.plannedArrival) || 'N/A'));
        overlayBody.appendChild(frameElement("Recorded arrival: ", formatDateTime(stop.recordedArrival) || 'N/A'));

        if (stop.manualArrival) {
            overlayBody.appendChild(frameElement("Manual arrival: ", formatDateTime(stop.manualArrival) || 'N/A'));
        }

        return overlayBody;
    }


    const getClusteredStopOption = (props, stops) => {

        const rootElement = document.createElement('div');

        const clusteredStop = document.createElement('div');
        clusteredStop.setAttribute("class", "cluster-box");
        clusteredStop.style.width = stops.numPoints * 48.5 + "px";

        for (var i = 0; i < stops.numPoints; i++) {
            clusteredStop.appendChild(getStopMarker(props, stops.points[i], i));
        }

        rootElement.appendChild(clusteredStop);

        return { element: rootElement }

    }

    const getStopMarker = (props, stop, index) => {
        
        const overlayContainer = document.createElement('div');
        overlayContainer.appendChild(frameStopOverlayHeader(stop));
        overlayContainer.appendChild(frameStopOverlayBody(stop));

        const stopMarker = document.createElement('div');
        stopMarker.textContent = stop.stopNumber;
        stopMarker.setAttribute("class", "stop-marker");
        stopMarker.style.left = index * 46 + 'px';
        stopMarker.style.bottom = index * 48 + 'px';
        if (stop.hasArrived) {
            stopMarker.style.background = "rgba(47, 191, 113, .9)";
        } else {
            stopMarker.style.background = "rgba(30, 42, 50, .5)";
        }

        const rootElement = document.createElement('div');
        rootElement.appendChild(frameOverlay(stop.stopNumber, overlayContainer));
        rootElement.appendChild(stopMarker);
        rootElement.onclick = function () { showStopOverlay(stop) };
        return rootElement;

    }

    const frameGPSOverlayHeader = (isLastKnownGpsLocation, gpsLocation) => {

        const overlayHeader = document.createElement('div');
        overlayHeader.setAttribute("class", "overlay-header");

        overlayHeader.textContent = isLastKnownGpsLocation ? 'Last known GPS location'
            : gpsLocation.manual ? 'Manual GPS location' : 'GPS location';

        return overlayHeader;
    }

    const frameGPSOverlayBody = (gpsLocation) => {

        const overlayBody = document.createElement('div');

        if (gpsLocation.manual) {
            overlayBody.setAttribute("class", "overlay-body-manual-marker");
        } else {
            overlayBody.setAttribute("class", "gps-overlay-body");
        }
        overlayBody.appendChild(frameElement("Latitude: ", gpsLocation.latitude));
        overlayBody.appendChild(frameElement("Longitude: ", gpsLocation.longitude));
        overlayBody.appendChild(frameElement("Timestamp: ", formatDateTime(gpsLocation.timestamp)));

        if (gpsLocation.manual) {
            const button = document.createElement('Button');
            button.textContent = "Remove";
            button.addEventListener("click", function () {
                props.deleteManualGPSLocation(gpsLocation.id, props.runId);
            });
            button.setAttribute("class", "btn btn-sm btn-danger")
            overlayBody.appendChild(button);
        }

            const copyToClipBoardButton = document.createElement('Button');
            copyToClipBoardButton.textContent = "Copy To Clipboard";
            copyToClipBoardButton.style.marginLeft = '5px';
            copyToClipBoardButton.addEventListener("click", function () {
                copyToClipBoard(gpsLocation.latitude + ',' + gpsLocation.longitude);
            });
            copyToClipBoardButton.setAttribute("class", "btn btn-sm")
            overlayBody.appendChild(copyToClipBoardButton);

        return overlayBody;

    }

    const copyToClipBoard = (latlngArg) => {
        
        var latlng = document.createElement("input");
        latlng.setAttribute("value", latlngArg);
        document.body.appendChild(latlng);
        latlng.select();
        document.execCommand("copy");
        document.body.removeChild(latlng);
    }

    const getGPSOption = (props, gpsLocation) => {

        const isLastKnownGpsLocation = isEqual(gpsLocation, props.lastGpsLocation);

        const overlayContainer = document.createElement('div');
        overlayContainer.appendChild(frameGPSOverlayHeader(isLastKnownGpsLocation, gpsLocation));
        overlayContainer.appendChild(frameGPSOverlayBody(gpsLocation));

        const rootElement = document.createElement('div');
        rootElement.appendChild(frameOverlay(gpsLocation.timestamp, overlayContainer));

        if (isLastKnownGpsLocation) {
            rootElement.appendChild(frameMarker(truckImageUrl, "truck-style"));
        } else {
            if (gpsLocation.manual) {
                rootElement.appendChild(frameMarker(manualMarkerUrl, "manual-marker-style"));
            } else {
                rootElement.appendChild(frameMarker(gpsMarkerUrl, "gps-marker-style"));
            }

        }
        rootElement.onclick = function () { showGPSOverlay(gpsLocation) };
        return { element: rootElement }
    };



    const showStopOverlay = stop => {
        setStopObj(stop);
        if (document.getElementById(stop.stopNumber).style.display === "block") {
            document.getElementById(stop.stopNumber).style.display = "none";
            setZIndex(document.getElementById(stop.stopNumber), 1);
        } else {
            if (previousStop !== 0) {
                document.getElementById(previousStop).style.display = "none";
                setZIndex(document.getElementById(previousStop), 1);
            }
            if (previousGPSLocation !== 0) {
                document.getElementById(previousGPSLocation).style.display = "none";
                setZIndex(document.getElementById(previousGPSLocation), 1);
            }
            document.getElementById(stop.stopNumber).style.display = "block";
            setZIndex(document.getElementById(stop.stopNumber), 100);
            previousStop = stop.stopNumber;
        }
    }


    const setZIndex = (element, value) => {
        element.parentElement.style.zIndex = value;
        // this condition is for the clustered stops
        element.parentElement.parentElement.parentElement.style.zIndex = value;
    }

    const showGPSOverlay = gpsLocation => {
        setGpsLocation(gpsLocation);
        if (document.getElementById(gpsLocation.timestamp).style.display === "block") {
            document.getElementById(gpsLocation.timestamp).style.display = "none";
            setZIndex(document.getElementById(gpsLocation.timestamp), 1);
        } else {
            if (previousStop !== 0) {
                document.getElementById(previousStop).style.display = "none";
                setZIndex(document.getElementById(previousStop), 1);
            }
            if (previousGPSLocation !== 0) {
                document.getElementById(previousGPSLocation).style.display = "none";
                setZIndex(document.getElementById(previousGPSLocation), 1);
            }
            document.getElementById(gpsLocation.timestamp).style.display = "block";
            setZIndex(document.getElementById(gpsLocation.timestamp), 100);
            previousGPSLocation = gpsLocation.timestamp;
        }
    }

    useEffect(() => {

        const { stopClusters, gpsClusters } = props;
        var map = new maps.DynamicMap(mapsElement.current, { ...props });        

        for (let itr = 0; itr < gpsClusters.length; itr++) {
                map.addMarker([(gpsClusters[itr].x), (gpsClusters[itr].y)], getGPSOption(props, gpsClusters[itr].points[0], gpsClusters[itr]));
        }

        for (let itr = 0; itr < stopClusters.length; itr++) {
            if (stopClusters[itr].numPoints > 1) {
                map.addMarker([(stopClusters[itr].x), (stopClusters[itr].y)], getClusteredStopOption(props, stopClusters[itr]));
            } else {
                map.addMarker([(stopClusters[itr].x), (stopClusters[itr].y)], {element: getStopMarker(props, stopClusters[itr].points[0], 0), fitToBounds: true});
            }
        }

    }, [props.gpsClusters, props.style, props.accessToken]);

    return <div className={props.className || 'toyota-map'} ref={mapsElement}></div>;

}
